import axios from '../../../node_modules/axios/index'
import router from './../../router'
import TWEEN from '@tweenjs/tween.js'

function tween(startValue, endValue) {
  function animate() {
    if (TWEEN.update()) {
      requestAnimationFrame(animate)
    }
  }

  new TWEEN.Tween({
      puntos: startValue
    })
    .to({
      puntos: endValue
    }, 2000)
    .onUpdate(function (object) {
      state.puntajeAnimado = object.puntos.toFixed(0)
    })
    .start()

  animate()
}

function get_ip() {
  axios.get('https://api.ipify.org?format=json')
    .then(res => {

      if (res.data.ip == '181.129.68.50') {
        //if(res.data.ip == '191.92.20.76'){
        var confirma = confirm('😃😃😃 \n ¡A partir de este momento ya tines acceso a internet!. \n ¿Desea continuar con el registro de sus datos 🤔?');
        if (!confirma) {
          location.href = "https://www.lacentral.com.co/";
        }
      }
    }).catch()
}

const state = {
  cliente: null,
  mascotasXCliente: null,
  puntajeActual: {
    registro: 0,
    informacionBasica: 0,
    fechaNacimiento: 0,
    estadoCivil: 0,
    contacto: 0,
    direccion: 0,
    categorias: 0,
    medioTransporte: 0
  },
  puntajeAnimado: 0,
  wifi: false,
  estadoWifi:false,
  ocupacion: [],
  mascota: []
};

const mutations = {
  setOcupaion(state, ocupacion){
    state.ocupacion = ocupacion
  },
  setMascotas(state, mascota){
    state.mascota = mascota
  },
  setCliente(state, cliente) {
    
    // if (cliente && cliente.subcategorias) {
    //   cliente.subcategorias.forEach(subcategoria => {
        
    //     subcategoria.svg = "data:image/svg+xml;utf8," + subcategoria.svg.replace("#", "%23")
        
    //   });
      
    // }
    
    state.cliente = cliente
  },
  resetCliente(state) {
    state.cliente = null;
  },
  setPuntaje(state, puntaje) {
    switch (puntaje.grupoDatosCliente) {
      case 1:
        state.puntajeActual.registro = puntaje.valor
        break;

      case 2:
        state.puntajeActual.informacionBasica = puntaje.valor
        break;

      case 3:
        state.puntajeActual.fechaNacimiento = puntaje.valor
        break;

      case 4:
        state.puntajeActual.estadoCivil = puntaje.valor
        break;

      case 5:
        state.puntajeActual.contacto = puntaje.valor
        break;

      case 6:
        state.puntajeActual.direccion = puntaje.valor
        break;

      case 7:
        state.puntajeActual.categorias = puntaje.valor
        break;

      case 8:
        state.puntajeActual.medioTransporte = puntaje.valor
        break;
    }
  },
  setPuntajeContacto(state, puntos) {
    state.puntajeActual.contacto = puntos
  },
  resetPuntajeActual(state) {
    state.puntajeActual = {
      registro: 0,
      informacionBasica: 0,
      fechaNacimiento: 0,
      estadoCivil: 0,
      contacto: 0,
      direccion: 0,
      categorias: 0,
      medioTransporte: 0
    }
  },
  resetPuntajeAnimado(state) {
    state.puntajeAnimado = 0
  }
};

const actions = {

  guardarCliente({
    commit,
    dispatch,
    rootGetters
  }, cliente) {
    commit('mostrarOcupado', 'Almacenando Información...')
    axios.post('/api/account/CompletarRegistroCentral', {
        email: rootGetters.userName,
        idTipoDocumento: cliente.idTipoDocumento,
        documento: cliente.documento,
        nombre1: cliente.nombre1,
        nombre2: cliente.nombre2,
        apellido1: cliente.apellido1,
        apellido2: cliente.apellido2,
        sexo: cliente.sexo,
        telefonoMovil: cliente.telefonoMovil,
        nombreCompleto: cliente.nombreCompleto,
        fechaNacimiento : cliente.fechaNacimiento

      })
      .then(res => {
        commit('setToken', res.data)
        dispatch('consultarCliente')
        commit('ocultarOcupado')
      })
      .catch(error=>{
        let mensaje = 'Se presentaron problemas almacenando tu información.'
        console.log(error)
        if (error) {
          mensaje = error.data
        }

        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error Guardando Información',
          contenido: mensaje,
          boton: {
            ruta: {
              name: 'completar-registro'
            },
            etiqueta: 'Intenta de nuevo'
          }
        })
        commit('ocultarOcupado')
      })
    
  },
  actualizarCliente({
    commit,
    dispatch,
    rootGetters
  },clienteActualizar){
    commit('mostrarOcupado', 'Actualizando Cliente, por favor espere...')
    axios.post('/api/account/ActualizarRegistroCentral', {
      email: rootGetters.userName,
      idTipoDocumento: clienteActualizar.idTipoDocumento,
      documento: clienteActualizar.documento,
      nombre1: clienteActualizar.nombre1,
      nombre2: clienteActualizar.nombre2,
      apellido1: clienteActualizar.apellido1,
      sexo: clienteActualizar.sexo,
      telefonoMovil: clienteActualizar.telefonoMovil,
      nombreCompleto: clienteActualizar.nombreCompleto,
      fechaNacimiento: clienteActualizar.fechaNacimiento,
      idCliente: clienteActualizar.idCliente
    })
    .then(res =>{
      commit('ocultarOcupado')
      let _cliente = rootGetters.cliente
      _cliente.telefonoMovil = clienteActualizar.telefonoMovil
      commit('setCliente', _cliente) 
    })
    .then(() =>{
      dispatch('redirigirCliente')

    })
    .catch(() => {
      dispatch('mostrarMensaje', {
        imagen: 'emo-sad',
        titulo: 'Error actualizando el registro del cliente',
        contenido: 'Se presentaron problemas al actualizar el cliente.',
        boton: {
          ruta: {
            name: 'completar-registro'
          },
          etiqueta: 'Volver a Intentar'
        }
      })

      commit('ocultarOcupado')
    });
  },
  validarWifi() {
    state.wifi = true
  },
  consultarListaMascotas({commit}){

  },
  async consultarCliente({
    commit,
    dispatch,
    rootGetters
  }) {
    commit('mostrarOcupado', 'Consultando Información...')
    
    await axios.post('/api/cliente/consultarCliente', {
        userId: rootGetters.userId
      })
      .then(res => {
        
        let cliente = res.data;
        //rootGetters = res.data;
        if (state.wifi && cliente != null) {
          
          commit('mostrarNotificiacionExito', 'A partir de este momento tienes acceso a internet.');
          setInterval(function () {
            var url = 'https://n264.network-auth.com/A-LA-CENTRAL-Wif/hi/nJg_ddbc/grant?continue_url=https://clientes.lacentral.com.co'
            window.location.replace(url)
          }, 3000);

        }
        let puntajeAnterior = rootGetters.totalPuntos;

        commit('setCliente', cliente);
        commit('setPuntaje', rootGetters.puntajeDatosCliente.registro);
        commit('setPuntaje', rootGetters.puntajeDatosCliente.informacionBasica);

        if (cliente.fechaNacimiento) {
          commit('setPuntaje', rootGetters.puntajeDatosCliente.fechaNacimiento)
        }

        if (cliente.estadoCivil && cliente.estadoCivil.length > 0) {
          commit('setPuntaje', rootGetters.puntajeDatosCliente.estadoCivil)
        }

        let valorCampo = Math.round(rootGetters.puntajeDatosCliente.contacto.valor / 5.0)
        let puntosContacto = 0
        if (cliente.email2 && cliente.email2.length >= 5) {
          puntosContacto += valorCampo
        }

        if (cliente.telefonoResidencia && cliente.telefonoResidencia.length >= 7) {
          puntosContacto += valorCampo
        }

        if (cliente.telefonoMovil && cliente.telefonoMovil.length >= 10) {
          puntosContacto += valorCampo
        }

        if (cliente.telefonoOtro && cliente.telefonoOtro.length >= 7) {
          puntosContacto += valorCampo
        }

        if (cliente.envioMail) {
          puntosContacto += valorCampo
        }

        if (cliente.envioSms) {
          puntosContacto += valorCampo
        }

        if (puntosContacto > rootGetters.puntajeDatosCliente.contacto.valor) {
          puntosContacto = rootGetters.puntajeDatosCliente.contacto.valor
        }

        if (puntosContacto > rootGetters.puntajeDatosCliente.contacto.valor - valorCampo + 1) {
          puntosContacto = rootGetters.puntajeDatosCliente.contacto.valor
        }

        commit('setPuntajeContacto', puntosContacto)

        if (cliente.direccion) {
          commit('setPuntaje', rootGetters.puntajeDatosCliente.direccion)
        }

        if (cliente.medioTransporte && cliente.medioTransporte > 0) {
          commit('setPuntaje', rootGetters.puntajeDatosCliente.categorias)
        }
        if (cliente.estadoCivil && cliente.estadoCivil > 0) {
          commit('setPuntaje', rootGetters.puntajeDatosCliente.categorias)
        }

        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)

      })
      .then(() => {

        let base_grant_url = localStorage.getItem('base_grant_url')
        let user_continue_url = localStorage.getItem('user_continue_url')

        if (base_grant_url) {

          localStorage.removeItem('base_grant_url')
          localStorage.removeItem('user_continue_url')

          let url = base_grant_url + "?continue_url=" + user_continue_url + "&duration=18000"
          window.location.replace(url)
        } else {
          dispatch('redirigirCliente')
        }
        commit('ocultarOcupado')
      })
      .catch((error) => {
        console.log(error)
        if (error.response.status == 404) {
          router.push({
            name: 'home'
          })
        } else {
          dispatch('mostrarMensaje', {
            imagen: 'emo-sad',
            titulo: 'Error consultando la información',
            contenido: 'Se presentaron problemas recuperando tu información.',
            boton: {
              ruta: {
                name: 'home'
              },
              etiqueta: 'Inicio'
            }
          })
        }
        commit('ocultarOcupado')
      })
  },
  guardarFechaNacimiento({
    commit,
    dispatch,
    rootGetters
  }, fecha) {
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarFechaNacimiento', {
        userId: rootGetters.userId,
        year: fecha.year,
        month: fecha.month,
        day: fecha.day
      })
      .then(() => {
        commit('ocultarOcupado')

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntaje', rootGetters.puntajeDatosCliente.fechaNacimiento)
        let puntajeNuevo = rootGetters.totalPuntos
        tween(puntajeAnterior, puntajeNuevo)
        let cliente = rootGetters.cliente;
        cliente.fechaNacimiento = new Date(fecha.year, fecha.month, fecha.day)
        commit('setCliente', cliente)
      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando la fecha',
          contenido: 'Se presentaron problemas almacenando tu fecha de nacimiento.',
          boton: {
            ruta: {
              name: 'fecha-nacimiento'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },
  guardarEstadoCivil({
    commit,
    dispatch,
    rootGetters
  }, estadoCivil) {
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarEstadoCivil', {
        userId: rootGetters.userId,
        estadoCivil
      })
      .then(() => {
        commit('ocultarOcupado')

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntaje', rootGetters.puntajeDatosCliente.estadoCivil)
        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)

        let cliente = rootGetters.cliente;
        cliente.estadoCivil = estadoCivil
        commit('setCliente', cliente)
      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando el estado civil',
          contenido: 'Se presentaron problemas almacenando tu estado civil.',
          boton: {
            ruta: {
              name: 'estado-categorias'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  guardarCantidadHijos({
    commit,
    dispatch,
    rootGetters
  }, cantidadHijos){
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarNumeroHijos',{ 
        userId: rootGetters.userId,
        cantidadHijos
      })
      .then(()=>{
        commit('ocultarOcupado')
        let cliente = rootGetters.cliente
        cliente.cantidadHijosMayoresEdad = cantidadHijos

        commit('setCliente', cliente)
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando la cantidad de hijos',
          contenido: 'Se presentaron problemas almacenando tu cantidad de hijos.',
          boton: {
            ruta: {
              name: 'categorias'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  guardarMascota({
    commit,
    dispatch,
    rootGetters
  }, mascota){
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarMascota', {
      idMascota: mascota,
      idCliente: rootGetters.idCliente
    })
    .then(()=> {
      commit('ocultarOcupado') 
      let cliente = rootGetters.cliente;
      if(cliente.mascotas.length == 0)
      {
        let _mascotas = {idMascota:mascota}
        cliente.mascotas.push(_mascotas)
      }  
        commit('setCliente', cliente)
    })
    .catch(() => {
      dispatch('mostrarMensaje', {
        imagen: 'emo-sad',
        titulo: 'Error almacenando la mascota',
        contenido: 'Se presentaron problemas almacenando tu mascota seleccionada.',
        boton: {
          ruta: {
            name: 'categorias'
          },
          etiqueta: 'Volver a Intentar'
        }
      })

      commit('ocultarOcupado')
    });

  },

  guardarProfesionCliente({
    commit,
    dispatch,
    rootGetters
  }, profesion){
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarProfesionXCliente',{
      idProfesion: profesion,
      idCliente: rootGetters.idCliente
    })
    .then(()=> {
      commit('ocultarOcupado') 
    
      let cliente = rootGetters.cliente;
      if(cliente.profesion.length == 0)
      {
        let _profesion = {idProfesion:profesion}
        cliente.profesion.push(_profesion)
      }
      commit('setCliente', cliente)

      let puntajeAnterior = rootGetters.totalPuntos
      commit('setPuntaje', rootGetters.puntajeDatosCliente.categorias)
      let puntajeNuevo = rootGetters.totalPuntos

      tween(puntajeAnterior, puntajeNuevo)
      
      
    })
    .then(() => {
      //dispatch('consultarCliente')
      dispatch('redirigirCliente')
    })
    .catch(() => {
      dispatch('mostrarMensaje', {
        imagen: 'emo-sad',
        titulo: 'Error almacenando la profesión',
        contenido: 'Se presentaron problemas almacenando tu profesión seleccionada.',
        boton: {
          ruta: {
            name: 'categorias'
          },
          etiqueta: 'Volver a Intentar'
        }
      })

      commit('ocultarOcupado')
    });

  },
  guardarContactoCliente({
    commit,
    dispatch,
    rootGetters
  }, contacto) {
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarContacto', {
        userId: rootGetters.userId,
        email2: contacto.email2,
        telefonoResidencia: contacto.telefonoResidencia,
        telefonoMovil: contacto.telefonoMovil,
        telefonoOtro: contacto.telefonoOtro,
        extension: contacto.extension,
        envioMail: contacto.envioMail,
        envioSms: contacto.envioSms
      })
      .then(() => {
        commit('ocultarOcupado')

        let valorCampo = Math.round(rootGetters.puntajeDatosCliente.contacto.valor / 5.0)
        let puntosContacto = 0
        if (contacto.email2 && contacto.email2.length >= 5) {
          puntosContacto += valorCampo
        }

        if (contacto.telefonoResidencia && contacto.telefonoResidencia.length >= 7) {
          puntosContacto += valorCampo
        }

        if (contacto.telefonoOtro && contacto.telefonoOtro.length >= 7) {
          puntosContacto += valorCampo
        }

        if (contacto.envioMail) {
          puntosContacto += valorCampo
        }

        if (contacto.envioSms) {
          puntosContacto += valorCampo
        }

        if (puntosContacto > rootGetters.puntajeDatosCliente.contacto.valor) {
          puntosContacto = rootGetters.puntajeDatosCliente.contacto.valor
        }

        if (puntosContacto > rootGetters.puntajeDatosCliente.contacto.valor - valorCampo + 1) {
          puntosContacto = rootGetters.puntajeDatosCliente.contacto.valor
        }

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntajeContacto', puntosContacto)
        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)

        let cliente = rootGetters.cliente

        cliente.email2 = contacto.email2
        cliente.telefonoResidencia = contacto.telefonoResidencia
        cliente.telefonoMovil = contacto.telefonoMovil
        cliente.telefonoOtro = contacto.telefonoOtro
        cliente.envioMail = contacto.envioMail
        cliente.envioSms = contacto.envioSms

        commit('setCliente', cliente)
      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando los datos de contacto',
          contenido: 'Se presentaron problemas almacenando tus datos de contacto.',
          boton: {
            ruta: {
              name: 'contacto'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  guardarDireccionCliente({
    commit,
    dispatch,
    rootGetters
  }, direccion) {
    commit('mostrarOcupado', 'Guardando Información...')
    console.log("guardar direccion metodo")
    axios.post('/api/cliente/GuardarDireccion', {
        userId: rootGetters.userId,
        idMunicipio: direccion.idMunicipio,
        idBarrio: direccion.idBarrio,
        tipoVia: direccion.tipoVia,
        numeroVia: direccion.numeroVia,
        interseccion: direccion.interseccion,
        complemento1: direccion.complemento1,
        complemento1Numero: direccion.complemento1Numero,
        complemento2: direccion.complemento2,
        complemento2Numero: direccion.complemento2Numero,
        complemento3:  direccion.complemento3,
        complemento3Numero: direccion.complemento3
      })
      .then(() => {
        commit('ocultarOcupado')

        let cliente = rootGetters.cliente;
        cliente.direccion = direccion
        commit('setCliente', cliente)

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntaje', rootGetters.puntajeDatosCliente.direccion)
        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)

      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando la dirección',
          contenido: 'Se presentaron problemas almacenando tu dirección.',
          boton: {
            ruta: {
              name: 'direccion'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  guardarMedioTransporte({
    commit,
    dispatch,
    rootGetters
  }, transporte) {
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarMedioTransporte', {
        userId: rootGetters.userId,
        medioTransporte: transporte.medioTransporte,
        placaVehiculo: transporte.placaVehiculo
      })
      .then(() => {
        commit('ocultarOcupado')

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntaje', rootGetters.puntajeDatosCliente.medioTransporte)
        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)

        let cliente = rootGetters.cliente;
        cliente.medioTransporte = transporte.medioTransporte
        cliente.placaVehiculo = transporte.placaVehiculo
        commit('setCliente', cliente)
      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando el medio de transporte',
          contenido: 'Se presentaron problemas almacenando tu medio de transporte.',
          boton: {
            ruta: {
              name: 'transporte'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  guardarSubcategoriasCliente({
    commit,
    dispatch,
    rootGetters
  }, subcategoriasSeleccionadas) {
    commit('mostrarOcupado', 'Guardando Información...')
    axios.post('/api/cliente/GuardarSubcategoriasCliente', {
        userId: rootGetters.userId,
        subcategorias: subcategoriasSeleccionadas
      })
      .then(() => {
        commit('ocultarOcupado')

        let puntajeAnterior = rootGetters.totalPuntos
        commit('setPuntaje', rootGetters.puntajeDatosCliente.categorias)
        let puntajeNuevo = rootGetters.totalPuntos

        tween(puntajeAnterior, puntajeNuevo)
      })
      .then(() => {
        dispatch('redirigirCliente')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error almacenando las categorías',
          contenido: 'Se presentaron problemas almacenando tus preferencias.',
          boton: {
            ruta: {
              name: 'categorias'
            },
            etiqueta: 'Volver a Intentar'
          }
        })

        commit('ocultarOcupado')
      });
  },

  redirigirCliente({
    rootGetters
  }) {
    let name = ''
    if (rootGetters.cliente.nombre1 && rootGetters.puntajeActual) {
      if (rootGetters.puntajeActual.direccion == 0) {
        //name = 'contacto'
        name = 'direccion' 
      } else if (rootGetters.puntajeActual.fechaNacimiento == 0) {
        //name = 'fecha-nacimiento'
        name = 'categorias'
      } 
      // else if (rootGetters.puntajeActual.estadoCivil == 0) {
      //   //name = 'estado-civil'
      //   name = 'categorias'
      // } else if (rootGetters.puntajeActual.medioTransporte == 0) {
      //   //name = 'transporte'
      //   name = 'categorias'
      // } 
      // else if (rootGetters.puntajeActual.estadoCivil == 0) {
      //   name = 'categorias'
      // } 
      else {
        name = 'home'
      }
    } else if (rootGetters.userId) {
      name = 'completar-registro'
    } else {
      name = 'login'
    }

    router.push({
      name: name
    })
  },
  consultarOcupacion({commit}){
    axios.get('/api/cliente/ConsultarProfesiones')
    .then((res) =>{
      if(res.status === 200){
        commit("setOcupaion", res.data)
      }
    })
    .catch((error)=>{
      console.log(error)
    })
  },
  consultarMascota({commit}){
    axios.get('/api/cliente/ConsultarMascotas')
    .then((res)=>{
      if(res.status === 200){
        commit("setMascotas", res.data)
      }
    })
    .catch((error)=>{
      console.log(error)
    })
  }
};

const getters = {
  puntajeActual(state) {
    return state.puntajeActual
  },
  totalPuntos(state) {
    var totalPuntos = 0

    for (var key in state.puntajeActual) {
      totalPuntos += state.puntajeActual[key]
    }

    return totalPuntos
  },
  totalPuntosAnimado(state) {
    return state.puntajeAnimado
  },
  cliente(state) {
    return state.cliente
  },
  mascotasXClientes(state){
    return state.mascotasXCliente
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};